import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, WritableSignal, computed, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GoogleMap, MapAdvancedMarker } from '@angular/google-maps';
import { ICoordinate } from 'src/app/core/models/coordinate.model';
import { ErrorService } from 'src/app/core/services/error.service';
import { EmptyMapComponent } from './components/empty-map/empty-map.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DialogService } from 'src/app/core/services/dialog.service';
import { GetMapsComponent } from '../../dialogs/get-maps/get-maps.component';
import { MapsFieldComponent } from '../../fields/maps-field/maps-field.component';

@Component({
  selector: 'app-input-maps-coordinate',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    GoogleMap,
    MapAdvancedMarker,
    EmptyMapComponent,
    MapsFieldComponent
  ],
  templateUrl: './input-maps-coordinate.component.html',
  styleUrl: './input-maps-coordinate.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputMapsCoordinateComponent implements OnInit {
  // @Input() coordinate?: ICoordinate
  @Input() name: string = '';
  @Input() form!: FormGroup;
  @Input() label?: string;
  @Input() labelError?: string;
  @Input() hint?: string;


  @ViewChild('myMap') map!: GoogleMap;

  hasCoordinate = signal(false);
  // coordinate = computed(() => this.form.get(this.name)?.value)
  coordinate: WritableSignal<google.maps.LatLngAltitudeLiteral | null> = signal(null);

  center: WritableSignal<google.maps.LatLngLiteral> = signal({ lat: 41.8992, lng: 12.5450 });
  zoom = 18;
  options: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    tilt: 0,
    clickableIcons: false,
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    zoomControl: false,
    scrollwheel: false,
    gestureHandling: 'none',
    keyboardShortcuts: false
  }

  constructor(
    private errorService: ErrorService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    if (this.coordinate() !== null) {
      this.center.set({
        lat: this.coordinate()!.lat,
        lng: this.coordinate()!.lng,
      });
      this.hasCoordinate.set(true);
    } else {
      navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
        this.center.set({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        })
      });
      this.hasCoordinate.set(false);
    }

    this.form.get(this.name)?.valueChanges.subscribe((value: any) => {
      this.coordinate.set(value);
      if (value) {
        this.hasCoordinate.set(true);
      } else {
        this.hasCoordinate.set(false);
      }
    })
  }


  hasError() {
    return this.form.get(this.name)?.invalid && (this.form.get(this.name)?.dirty || this.form.get(this.name)?.touched);
  }

  error() {
    const errors = Object.entries(
      this.form.get(this.name)?.errors || {}
    );
    return this.errorService.getErrorValidationMessage(this.labelError ?? this.label ?? this.name, errors);
  }

  openSelectMapDialog(): void {
    const dialogRef = this.dialogService.open(GetMapsComponent, {
      data: {
        coordinate: this.coordinate()
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.form.get(this.name)?.patchValue(result);
        this.form.get(this.name)?.markAsTouched();
        this.form.get(this.name)?.markAsDirty();
      }
    });
  }
}
